/** Render Algolia highlight HTML or fallback plain text with manual mark. */
export default function AlgoliaHighlight({ html, text, query, className = "" }) {
  if (html && html.includes("<mark")) {
    return (
      <span
        className={className}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
  if (!text || !query) return <span className={className}>{text}</span>;
  const i = text.toLowerCase().indexOf(query.toLowerCase());
  if (i < 0) return <span className={className}>{text}</span>;
  return (
    <span className={className}>
      {text.slice(0, i)}
      <mark className="algolia-hit">{text.slice(i, i + query.length)}</mark>
      {text.slice(i + query.length)}
    </span>
  );
}
